let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1ruJB"), load("jkTol"), load("ffEVr"), load("4Kqu1")]).then(() => parcelRequire('i6jK3'));